<template>
  <modal @close="close" class="md-layout" width="95%">
    <md-toolbar :class="headerClass" md-elevation="1" slot="header">
      <h4>
        <strong>
          Fotos de seguridad
          {{realPlan.planExpected.sinisterNumber}}
          {{realPlan.finishsToday | finishMessage}}
        </strong>
      </h4>
    </md-toolbar>

    <template slot="body">
      <notifications />
      <tabs id="photo-security-tabs" :cache-lifetime="0.00000" :options="tabOptions">
        <tab
          v-for="workingDay in workingDays"
          :key="workingDay.startDateFormatted"
          :id="`${workingDay.startDateFormatted}-security-photos`"
          :name="`${workingDay.startDateFormatted} ${workingDay.startDateFormatted === realPlan.date ? '(hoy)' : ''} ${getWorkingDayClass(workingDay)}`"
          header="foo"
          class="security-photo-tab"
        >
          <security-photos
            :reasons="reasons"
            :forceReadOnly="workingDay.startDateFormatted !== realPlan.date"
            :realPlan="{
            ...realPlan,
            date: workingDay.startDateFormatted
          }"
            @allReasonsUploaded="updateStatus"
            @uploadedPhotos="emitUploaded"
          />
        </tab>
      </tabs>
    </template>
  </modal>
</template>

<script>
import SecurityPhotos from "./../SecurityPhotos";
import moment from "moment";

const finishMessage = (status) => (status && " | Finaliza hoy") || "";

export default {
  name: "SecurityPhotosModal",

  props: {
    realPlan: Object,
    reasons: Array,
  },

  components: {
    SecurityPhotos,
  },

  filters: { finishMessage },

  methods: {
    close() {
      this.$emit("close");
    },
    updateStatus(value) {
      this.allReasonsUploaded = value;
      this.$emit("allReasonsUploaded", value);
    },
    emitUploaded(payload) {
      this.$emit("uploadedPhotos", payload);
    },
    getWorkingDayClass(workingDay) {
      const { allSecurityPhorosUploaded, isToday } = workingDay;
      if (allSecurityPhorosUploaded || (isToday && this.allReasonsUploaded)) {
        return "";
      } else {
        return "*";
      }
    },
  },

  computed: {
    headerClass() {
      const readOnly = this.realPlan && this.realPlan.readOnly;
      if (this.allReasonsUploaded) {
        return "md-success";
      } else if (readOnly) {
        return "md-danger";
      }
      return "md-warning";
    },
    date() {
      const { date } = this.realPlan;
      return date || moment(new Date()).format("YYYY-MM-DD");
    },
    workingDays() {
      const { workingDays, finishDate } = this.realPlan;
      const hasToday = workingDays
        .map(({ startDateFormatted }) => startDateFormatted)
        .includes(this.date);
      return !!finishDate || hasToday
        ? workingDays
        : [...workingDays, { startDateFormatted: this.date }];
    },
    tabOptions() {
      return {
        defaultTabHash: `${this.realPlan.date}-security-photos`,
        useUrlFragment: false,
      };
    },
  },

  data() {
    return {
      allReasonsUploaded: null,
    };
  },
};
</script>

<style scoped>
.tabs-component {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/SecurityPhotosModal.vue